<template>
  <section v-if="!closed" class="cookie_disclaimer">
    <IconDefault class="close_button" name="cross" @click="close()" />
    <p>Нажимая кнопку «Принимаю», вы&nbsp;даёте <a href="/cookie.pdf" target="_blank">согласие</a> на&nbsp;обработку ваших персональных данных, собираемых с&nbsp;помощью файлов cookie и&nbsp;сервисов сбора технических данных посетителей, для&nbsp;целей предоставления персонализированного доступа к&nbsp;контенту и&nbsp;сервисам Сайта, а&nbsp;именно: администрирования и&nbsp;улучшения Сайта</p>
    <div class="accept_button">
      <AppButton type="black" size="xs" text="Принимаю" isFluid @click="close()"></AppButton>
    </div>
  </section>
</template>
<script setup lang="ts">
import {useCookie} from "nuxt/app";
import AppButton from "@components/AppButton/index.vue"
import IconDefault from "@components/AppIcon/index.vue"
defineOptions({
  name: 'CookieDisclaimer'
})
const closed = useCookie('cookie_disclaimer_closed')

function close() {
  closed.value = '1'
}
</script>
<style scoped lang="scss">
.cookie_disclaimer {
  position: fixed;
  z-index: var(--z-index-cookie-disclaimer);
  left: var(--space-60);
  right: var(--space-60);
  bottom: var(--space-32);
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  gap: var(--space-40);
  max-width: 95rem;
  margin: 0 auto;
  padding: var(--space-20) var(--space-40) var(--space-10);
  border-radius: var(--space-16);
  background: var(--color-primary);
  .close_button {
    position: absolute;
    z-index: 1;
    top: 1.1rem;
    right: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.3rem;
    height: 1.3rem;
    color: var(--color-black);
    cursor: pointer;
  }
  p {
    margin-bottom: 0;
    color: var(--color-black);
    font-size: var(--font-size-14);
    line-height: 1.3;
    a {
      text-decoration: underline 1px;
      text-underline-offset: 2px;
      color: var(--color-black);
    }
  }
  .accept_button {
    width: 42rem;
    margin-bottom: 1.2rem;
  }
  @media screen and (max-width: 768px) {
    left: var(--space-16);
    right: var(--space-16);
    bottom: var(--space-16);
    gap: var(--space-12);
    flex-direction: column;
    padding: var(--space-16);
    p {
      font-size: var(--font-size-12);
    }
    .close_button {
      top: 1rem;
      right: 1.3rem;
    }
    .accept_button {
      width: auto;
      margin-bottom: 0;
    }
  }
}
</style>